module.exports = __webpack_public_path__ + "static/media/mv.c11e6efe.svg";